/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'dns-policy';
const componentName = 'dns-policy-list';
const prefix = `${moduleName}.${componentName}`;

export const columnTitleTotalDnsRules = `${prefix}.columnTitleTotalDnsRules`;
export const gridPlaceholder = `${prefix}.gridPlaceholder`;

export const ENGLISH = {
    [columnTitleTotalDnsRules]: '# DNS Rules',
    [gridPlaceholder]: 'No Items Found',
};
